const {
  GET_ALL_RESERVOIR_REQUEST,
  GET_ALL_RESERVOIR_SUCCESS,
  GET_ALL_RESERVOIR_FAIL,
  GET_RESERVOIR_REQUEST,
  GET_RESERVOIR_SUCCESS,
  GET_RESERVOIR_FAIL,
  ADD_RESERVOIR_REQUEST,
  ADD_RESERVOIR_SUCCESS,
  ADD_RESERVOIR_FAIL,
  UPDATE_RESERVOIR_REQUEST,
  UPDATE_RESERVOIR_SUCCESS,
  UPDATE_RESERVOIR_FAIL,
  DELETE_RESERVOIR_REQUEST,
  DELETE_RESERVOIR_SUCCESS,
  DELETE_RESERVOIR_FAIL,
} = require("../../actionTypes/Paramaetrage/Reservoir");

function getAllReservoirs(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_RESERVOIR_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_RESERVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_RESERVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getReservoirById(state = { data: {} }, action) {
  switch (action.type) {
    case GET_RESERVOIR_REQUEST:
      return { loading: true, data: {} };
    case GET_RESERVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_RESERVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addReservoir(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_RESERVOIR_REQUEST:
      return { loading: true, data: {} };
    case ADD_RESERVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_RESERVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateReservoir(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_RESERVOIR_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_RESERVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_RESERVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteReservoir(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_RESERVOIR_REQUEST:
      return { loading: true, data: {} };
    case DELETE_RESERVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_RESERVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addReservoir,
  updateReservoir,
  deleteReservoir,
  getAllReservoirs,
  getReservoirById,
};
